export default "__VITE_ASSET__BMJeHoHB__"